<template>
    <div id="issuesReportedList">
        <div :class="`loader${loaderClass}`" v-show="loading">

        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">Reported Issues List
                        <!-- <data-table-column-config :moduleName="'issuesReportedList'"></data-table-column-config> -->
                    </div>
                    <div class="admin-page-content">
                        <section class="data-table bg-white">
                        <data-table-filter-config :moduleName="'issuesReportedList'" @cancelSelection="cancelAll"></data-table-filter-config>

                            <!-- <div class="container"> -->
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'issuesReportedList'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listIssueReportedTable"
                                    mode="remote"
                                    title="Feedback"
                                    @on-page-change="onPageChange"
                                    @on-per-page-change="onPerPageChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'" class='btn-center-vvg'>

                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <!-- <div>
                                        <v-select placeholder="Select Status" class="custom-class pull-left" v-model="status" label="text" :options="statusArr"></v-select>
                                    </div> -->
                                    <div slot="selected-row-actions" v-if="loggedInUser == 'fleetpro@vvgtruck.com'">
                                        <button id="deleteLocationBtn" v-on:click.prevent="changeStatus" class="btn btn-success waves-effect pull-right">Change Status</button>
                                        <v-select placeholder="Select Status" v-model="status" label="text" :options="statusArr"></v-select>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                            <!-- </div> -->
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from "././event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "issuesReportedList",
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
             permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Subject',
                    field: 'subject',
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Subject", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Description',
                    field: 'description',
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Reported By',
                    field: 'user_id',
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Reported By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'URL',
                    field: 'url',
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "URL", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Notified By',
                    field: 'notification_type',
                    filterable: true,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Notified By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Email','Zoom'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    filterable: true,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Notified By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Issue','In progress','Closed'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'TimeSlot',
                    field: 'time_slot',
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "TimeSlot", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status Changed By',
                    field: 'updated_by',
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status Changed By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Actions',
                //     field: 'action',
                //     sortable: false,
                // },
            ],
            rows: [],
            totalRecords: 0,
            location_value: false,
            loading:false,
            statusArr:[{text:'Issue',value:'issue'},{text:'In Progress',value:'in progress'},{text:'Closed',value:'closed'}],
            status:'',
            loggedInUser:'',
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_location') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            self.getPermissions();

             var userObj = JSON.parse(localStorage.getItem("user_obj"));
            if (userObj != null) {
                // var userJson = JSON.parse(userObj);
               self.loggedInUser = userObj.email;
            }
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listIssueReportedTable.unselectAllInternal();
            },
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                };

                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/issue-reported/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == 'success') {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            changeStatus: function(){
                var self = this;

                var selectedRows = [];

                //because on first load list not initialize
                var data = this.$refs['listIssueReportedTable'].selectedRows;
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(this.$refs['listIssueReportedTable'].selectedRows[i].id)
                }
                var error = false;
                if ( self.status == null || !self.status.value){
                    self.$swal('','Please choose a status','warning');
                    error = true;
                }

                if (!error){

                    $.ajax({
                        url: process.env.ROOT_API + "/issue-status/change",
                        type: "POST",
                        data: {selectedRows:selectedRows,status:self.status.value},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            // console.log(data);
                            self.loadList();
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");
                                    self.$router.push("/");
                                }
                                self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }
            }
        }
    };
</script>
<style scoped>
.side-search{

    margin-right: 0% !important;
    float: right;
    width: 200% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/IssuesReported.vue